import { Link } from 'react-router-dom';
import { Avatar, Box, ListItem, ListItemAvatar, ListItemText } from '@mui/material';
import './CartDropdownHeader.scss';

type CartDropdownHeaderProps = {
  title: string;
  className: string;
  image: string;
  imageAlt: string;
  linkUrl: string;
  linkText: string;
  toggleCart?: () => void;
};

const CartDropdownHeader = ({
  className,
  imageAlt,
  image,
  linkUrl,
  linkText,
  title,
  toggleCart
}: CartDropdownHeaderProps) => (
  <Box className={`${className} cart-dropdown-header`}>
    <ListItem>
      <ListItemAvatar>
        <Avatar className='image' variant='rounded' alt={imageAlt} src={image} />
      </ListItemAvatar>
      <ListItemText
        primary={<span className='title'>{title}</span>}
        secondary={
          <Link to={linkUrl} onClick={toggleCart}>
            {linkText}
          </Link>
        }
      />
    </ListItem>
  </Box>
);

export default CartDropdownHeader;
